import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { fetchWithAuth } from "../api/fetchWithAuth";

const initialForm = {
  number: "",
  name: "",
  swReqs: "",
  status: ""
};

function formatSwReqs(value) {
  if (!Array.isArray(value)) return "";
  return value.join(", ");
}

function SWComponentFormModal({ show, onClose, onSaved, component }) {
  const isEdit = Boolean(component);
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (component) {
      setForm({
        number: component.number ?? "",
        name: component.name ?? "",
        swReqs: formatSwReqs(component.swReqs),
        status: component.status ?? ""
      });
    } else {
      setForm(initialForm);
    }
  }, [component, show]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((current) => ({
      ...current,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    const url = isEdit
      ? `/api/sw-components/${component.id}`
      : "/api/sw-components";
    const method = isEdit ? "PUT" : "POST";

    const res = await fetchWithAuth(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...form,
        swReqs: form.swReqs
      })
    });

    if (!res.ok) {
      const error = await res.json().catch(() => null);
      alert(error?.error || "Save failed");
      return;
    }

    onSaved();
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {isEdit ? "Edit SW Component" : "Add SW Component"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Number</Form.Label>
            <Form.Control name="number" value={form.number} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="name"
              value={form.name}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>SW Requirements</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="swReqs"
              value={form.swReqs}
              onChange={handleChange}
              placeholder="Requirement ids separated by comma"
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Control name="status" value={form.status} onChange={handleChange} />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SWComponentFormModal;
